export default "__VITE_ASSET__DwLxSUsQ__"